const VERIFYCODE_LIMIT_TIME = 60

export default {
  data() {
    return {
      currentSecond: 0, // 获取验证码限制时间
      isGetting: false // 是否在获取验证码中，防止多次触发
    }
  },

  methods: {
    /*
     * 获取验证 码倒计时
     */
    countDown(time = VERIFYCODE_LIMIT_TIME) {
      this.currentSecond = time
      --time
      this.countDownTimer = setTimeout(() => {
        if (time <= 0) {
          this.isGetting = false
          clearTimeout(this.countDownTimer)
        } else {
          this.countDown(time)
        }
      }, 1000)
    }
  },

  destroyed() {
    clearTimeout(this.countDownTimer)
  }
}
